import dayjs from "dayjs"
import { IBasicOption, ILocation, Nullable, RuleStatus, RuleType } from "../../types";

export interface IFormValuesRulesFilter {
    status: {
        value: RuleStatus,
        label: string
    } | null,
    type: {
        value: RuleType,
        label: string
    } | null,
    name: string,
    creationDateFrom: dayjs.Dayjs | null,
    creationDateTo: dayjs.Dayjs | null,
    user: string,
    startDateTimeFrom: dayjs.Dayjs | null,
    startDateTimeTo: dayjs.Dayjs | null,
    endDateTimeFrom: dayjs.Dayjs | null,
    endDateTimeTo: dayjs.Dayjs | null,
    tenants: string[],
    dealers?: string[]
}

export interface IFormValuesRule {
    type: RuleType,
    name: string,
    bookingDateFrom: Nullable<dayjs.Dayjs>,
    bookingDateTo: Nullable<dayjs.Dayjs>,
    skip: number,
    applyFor?: number,
    mailingList?: string[],
    alertOnSetting?: boolean,
    alertOnActivation?: boolean,
    pickupDateTimeFrom?: {
        value: Nullable<dayjs.Dayjs>,
        excluded: boolean
    },
    pickupDateTimeTo?: {
        value: Nullable<dayjs.Dayjs>,
        excluded: boolean
    },
    dropoffDateTimeFrom?: {
        value: Nullable<dayjs.Dayjs>,
        excluded: boolean
    },
    dropoffDateTimeTo?: {
        value: Nullable<dayjs.Dayjs>,
        excluded: boolean
    },
    includingDateTimeFrom?: {
        value: Nullable<dayjs.Dayjs>,
        excluded: boolean
    },
    includingDateTimeTo?: {
        value: Nullable<dayjs.Dayjs>,
        excluded: boolean
    },
    pickupLocations?: {
        value: ILocation[],
        excluded: boolean
    },
    dropoffLocations?: {
        value: ILocation[],
        excluded: boolean
    },
    pickupAreas?: {
        value: string[],
        excluded: boolean
    },
    dropoffAreas?: {
        value: string[],
        excluded: boolean
    },
    pickupRegions?: {
        value: string[],
        excluded: boolean
    },
    dropoffRegions?: {
        value: string[],
        excluded: boolean
    },
    pickupZones?: {
        value: string[],
        excluded: boolean
    },
    dropoffZones?: {
        value: string[],
        excluded: boolean
    }
    acrissList?: {
        value: string[],
        excluded: boolean
    },
    sippList?: {
        value: string[],
        excluded: boolean
    },
    customerCodes?: {
        value: string[],
        excluded: boolean
    },
    salesChannels?: {
        value: IBasicOption[],
        excluded: boolean
    },
    segments?: {
        value: {
            code: string,
            label: string
        }[],
        excluded: boolean
    },
    categories?: {
        value: {
            code: string,
            label: string
        }[],
        excluded: boolean
    },
    products?: {
        value: {
            code: string,
            label: string
        }[],
        excluded: boolean
    },
    rates?: {
        value: {
            code: string,
            label: string
        }[],
        excluded: boolean
    },
    ancillaries?: {
        value: {
            code: string,
            label: string
        }[],
        excluded: boolean
    },
    minDuration?: {
        value: number,
        excluded: boolean
    },
    maxDuration?: {
        value: number,
        excluded: boolean
    },
    minNoticeDays?: {
        value: number,
        excluded: boolean
    },
    maxNoticeHours?: {
        value: number,
        excluded: boolean
    },
    tenants: string[],
    dealers: string[]
}

export enum RuleConstraint {
    PickupDateTimeFrom = 'PICKUP_DATE_TIME_FROM',
    PickupDateTimeTo = 'PICKUP_DATE_TIME_TO',
    DropoffDateTimeFrom = 'DROPOFF_DATE_TIME_FROM',
    DropoffDateTimeTo = 'DROPOFF_DATE_TIME_TO',
    IncludingDateTimeFrom = 'INCLUDING_DATE_TIME_FROM',
    IncludingDateTimeTo = 'INCLUDING_DATE_TIME_TO',
    PickupLocations = 'PICKUP_LOCATIONS',
    DropoffLocations = 'DROPOFF_LOCATIONS',
    PickupAreas = 'PICKUP_AREAS',
    DropoffAreas = 'DROPOFF_AREAS',
    PickupRegions = 'PICKUP_REGIONS',
    DropoffRegions = 'DROPOFF_REGIONS',
    PickupZones = 'PICKUP_ZONES',
    DropoffZones = 'DROPOFF_ZONES',
    AcrissList = 'ACRISS_LIST',
    SippList = 'SIPP_LIST',
    CustomerCodes = 'CUSTOMER_CODES',
    SalesChannels = 'SALES_CHANNELS',
    Segments = 'SEGMENTS',
    Categories = 'CATEGORIES',
    Products = 'PRODUCTS',
    Rates = 'RATES',
    Ancillaries = 'ANCILLARIES',
    MinDuration = 'MIN_DURATION',
    MaxDuration = 'MAX_DURATION',
    MinNoticeDays = 'MIN_NOTICE_DAYS',
    MaxNoticeHours = 'MAX_NOTICE_HOURS'
};